import {
  ContactLanguages,
  type ContentApi,
  Languages,
  type MiscContent,
  type MiscContentType,
} from "@/briefpoint-client";
import type { EmailData } from "@/lib/types";

export const retrieveEmailContent = async (
  contentApi: ContentApi,
  language: ContactLanguages | undefined,
  type:
    | MiscContentType.ExternalCommunicationEmail
    | MiscContentType.ExternalCommunicationReminderEmail,
  emailContent: React.Dispatch<React.SetStateAction<MiscContent | undefined>>,
  emailBody?: React.Dispatch<React.SetStateAction<string>>,
  emailSubject?: React.Dispatch<React.SetStateAction<string>>,
): Promise<void> => {
  const emails = await contentApi.contentGetAllMiscContent({ type });

  if (emails) {
    const langEmails: MiscContent[] = emails.filter(
      (x) =>
        x.language ===
        (language === ContactLanguages.Spanish ? Languages.Spanish : undefined),
    );

    const email =
      langEmails
        .sort((a, b) => a.id?.localeCompare(b.id ?? "") ?? 0)
        .find(
          (e) => !e.name?.localeCompare("User_External_Communication_Email"),
        ) ||
      langEmails[0] ||
      emails[0];

    let emailData: EmailData;

    try {
      emailData = JSON.parse(email.content ?? "") as EmailData;
    } catch (error) {
      console.error(error);
      emailData = { body: "", subject: "" };
    }

    emailContent(email);
    if (emailBody) emailBody(emailData.body);
    if (emailSubject) emailSubject(emailData.subject);
  }
};
